/**
 * THE rule for "let the game decide": one uniform pick over the legal options.
 *
 * Two places hand an undecided travel choice to chance — `forceTurnEnd` when
 * the timer beats the player to it, and the Ready gate's second tap — and they
 * are documented as applying the same rule, so the pick lives here and both
 * call it. (forceTurnEnd used to roll `round(random * n/2)`, which could never
 * reach the last option and favoured the middle ones.)
 *
 * The clamp guards `random()` returning exactly 1 (a custom generator may),
 * which would otherwise index one past the end.
 */
export function pickUniformRandom<T>(items: readonly T[], random: () => number = Math.random): T | undefined {
  if (!items.length) {
    return undefined
  }
  return items[Math.min(items.length - 1, Math.floor(random() * items.length))]
}
